const GTM_ID = import.meta.env.VITE_GTM_ID || ''

let injected = false

function injectScript() {
  if (injected || !GTM_ID) return
  injected = true
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })
  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(s)
}

// "accepted" (aceitar todos) sempre libera; "custom" só libera se a
// categoria analytics foi marcada no painel de personalização.
function hasAnalyticsConsent() {
  const consent = localStorage.getItem('kali-cookie-consent')
  if (consent === 'accepted') return true
  if (consent !== 'custom') return false
  try {
    const categories = JSON.parse(localStorage.getItem('kali-cookie-consent-categories') || '{}')
    return !!categories.analytics
  } catch {
    return false
  }
}

export function initGtm(router) {
  if (typeof window === 'undefined' || !GTM_ID) return

  // Carrega imediatamente se o usuário já havia dado consentimento
  if (hasAnalyticsConsent()) {
    injectScript()
  }

  // Só carrega com aceite explícito — fechar o banner sem decidir ou
  // rejeitar NÃO conta como consentimento (opt-out real de analytics).
  window.addEventListener('cookies-accepted', injectScript, { once: true })

  // Envia page_view a cada mudança de rota (SPA)
  router?.afterEach((to) => {
    pushEvent('page_view', {
      page_path: to.path,
      page_title: document.title,
    })
  })
}

// Envia um evento para o dataLayer do GTM.
// No-op se GTM_ID não estiver configurado ou durante a build SSG.
export function pushEvent(name, params = {}) {
  if (typeof window === 'undefined' || !GTM_ID) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: name, ...params })
}
